import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { createLogger } from '@hunting-nature/shared-core/logging';
import { catchError, from, map, of, switchMap } from 'rxjs';

import { GeneralActions } from '../../../shared/redux/general/general.actions';
import { SettingsService } from '../../../shared/services/settings.service';
import { WHATS_NEW_ID } from '../shared/whats-new.config';

import { WhatsNewActions } from './whats-new.actions';

@Injectable()
export class WhatsNewEffects {
  // services
  private readonly actions$ = inject(Actions);
  private readonly settingsService = inject(SettingsService);
  private readonly log = createLogger('WhatsNewEffects');

  // A successful login (fired on every authenticated app start) triggers the "seen" check.
  loginTriggeredWhatsNew$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeneralActions.loginSucceeded),
      map(() => WhatsNewActions.checkWhatsNew())
    )
  );

  checkWhatsNew$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WhatsNewActions.checkWhatsNew),
      switchMap(() =>
        from(this.settingsService.getWhatsNewSeen$()).pipe(
          map(seenId => WhatsNewActions.checkWhatsNewSucceeded({ shouldShow: seenId !== WHATS_NEW_ID })),
          catchError((error: unknown) => {
            this.log.error('Reading whats-new seen flag failed', { error });
            return of(WhatsNewActions.checkWhatsNewFailed({ error }));
          })
        )
      )
    )
  );

  // Persist the seen flag when the walkthrough is dismissed so it is never shown again.
  dismissWhatsNew$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WhatsNewActions.dismissWhatsNew),
      switchMap(() =>
        from(this.settingsService.setWhatsNewSeen$(WHATS_NEW_ID)).pipe(
          map(() => WhatsNewActions.dismissWhatsNewSucceeded()),
          catchError((error: unknown) => {
            this.log.error('Persisting whats-new seen flag failed', { error });
            return of(WhatsNewActions.dismissWhatsNewFailed({ error }));
          })
        )
      )
    )
  );
}
